module.exports = __webpack_public_path__ + "img/plus.52745952.svg";